import { RootState } from "../../../types/redux-types";

export const selectToken = (state: RootState) =>
  state.authentication.user?.authData?.accessToken;
export const selectAvatar = (state: RootState) =>
  state.authentication.user?.photoURL;
export const selectAuthError = (state: RootState) =>
  state.authentication.authError;
export const selectUser = (state: RootState) => state.authentication.user;
